module.exports = __webpack_public_path__ + "media/images/ui-icons_555555_256x240-e30ce9397cddc63d3f1827d1d7153edf.png";